export function booleanToHighLow(value) {
  if (value === null || value === undefined) {
    return 'n/a';
  }
  return value ? 'High' : 'Low';
}
